<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Apps | {{id}}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
          <div class="form-group col-12 col-md-6">
            <label for="descricao">Descrição: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.descricao }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="status_desc">Status: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.status_desc }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="possui_numero_viagens_desc">Possui número de viagens: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.possui_numero_viagens_desc }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="possui_segmentos_desc">Possui segmentos: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.possui_segmentos_desc }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="possui_segmentos_desc">Usa imagens: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.idc_usa_imagem === 1 ? "Sim"  : "Näo"}}
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Voltar</button>
            <button type="button" id="editarButton" class="btn btn-info" @click="editar()">Editar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AplicativoActions from '../../actions/AplicativoActions'

export default {
  name: 'detalhes',
  props: ['id'],
  data () {
    return {
      registro: {
        descricao: '',
        idc_status: '',
        status_desc: '',
        idc_imagem: ''
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Detalhes'

    AplicativoActions.obter(this.id)
      .then(res => {
        if (res && res.descricao) {
          this.registro = res
        } else {
          this.errorMessage = 'Registro não encontrado.'
        }
      })
      .catch((error) => {
        console.log(error.message)
        this.errorMessage = 'Registro não encontrado.'
      })
  },
  methods: {
    voltar () {
      this.$router.push('/aplicativos')
    },
    editar () {
      this.$router.push('/aplicativos/' + this.id + '/e')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/aplicativos/Detalhes.vue